<div>
  <div class="md:flex md:items-center md:justify-between py-8">
    <div class="min-w-0 flex-1">
      <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Commandes</h2>
    </div>
    <!-- <div class="mt-4 flex md:ml-4 md:mt-0">
      <button
        type="button"
        class="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
      >
        Factures
      </button>
    </div> -->
  </div>
</div>

<div>
  <select
    id="orders"
    (change)="onChange($event)"
    name="orders"
    class="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-stone-600 sm:text-sm sm:leading-6"
  >
    <option value="-1">Toutes les commandes</option>
    @for(status of orderStatus; track status.id) {
    <option value="{{ status.id }}">{{ status.name }}</option>
    }
  </select>
</div>

<ul role="list" class="divide-y divide-gray-100" style="margin-top: 10px">
  @for(order of filteredOrder; track order) {
  <li class="bg-white border-b-1 border-gray-500 px-2">
    <app-order-line [order]="order" />
  </li>
  }
</ul>
